<div class="modal-header">
    <h4 class="modal-title" id="modal-title">
        Motivo de desactivación de la empresa
    </h4>
    <button
        type="button"
        class="btn-close"
        aria-label="Cerrar"
        (click)="cancelar()"></button>
</div>
<div class="modal-body">
    <div *ngIf="isLoading" class="text-center">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>
        <p>Cargando información...</p>
    </div>

    <div *ngIf="!isLoading && errorMessage" class="alert alert-warning">
        {{ errorMessage }}
    </div>

    <div *ngIf="!isLoading && !errorMessage">
        <form [formGroup]="form">
            <div class="mb-3">
                <label for="motivo" class="form-label">
                    Seleccione un motivo
                </label>
                <select
                    id="motivo"
                    class="form-select"
                    formControlName="motivo">
                    <option value="" disabled>-- Seleccione --</option>
                    <option *ngFor="let m of motivos" [value]="m.id">
                        {{ m.nombre }}
                    </option>
                    <option value="otro">Otro motivo</option>
                </select>
            </div>

            <div class="mb-3" *ngIf="otroMotivoSeleccionado">
                <label for="otroMotivo" class="form-label">
                    Especifique otro motivo
                </label>
                <input
                    id="otroMotivo"
                    type="text"
                    class="form-control"
                    formControlName="otroMotivo"
                    placeholder="Ingrese el motivo de desactivación" />
            </div>
        </form>
    </div>
</div>
<div class="modal-footer">
    <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="cancelar()">
        Cancelar
    </button>
    <button
        type="button"
        class="btn btn-success"
        (click)="confirmar()"
        [disabled]="form.invalid">
        Confirmar
    </button>
</div>
